import { NgModule } from '@angular/core';
import { AppCommonModule } from './appcommon.module';
import { AppFormModule } from './appform.module';
import { TableStatusModule } from '../components/table/tablestatus.module';
import { TableFilterModule } from '../components/tablefilter/tablefilter.module';
import { AvatarComponent } from '../components/avatar/avatar.component';

@NgModule({
    declarations: [AvatarComponent],
    imports: [AppCommonModule, AppFormModule, TableStatusModule, TableFilterModule],
    exports: [TableStatusModule, AvatarComponent, TableFilterModule]
})
export class AppComponentModule {

}